import React, { createContext, useContext, useState } from 'react';

const RegistrationContext = createContext();

export const useRegistration = () => {
  const context = useContext(RegistrationContext);
  if (!context) {
    return {
      registrationStep: 1,
      setRegistrationStep: () => { } // Defensive no-op to prevent runtime errors
    };
  }
  return context;
};

export const RegistrationProvider = ({ children }) => {
  const [registrationStep, setRegistrationStep] = useState(1);

  return (
    <RegistrationContext.Provider value={{ registrationStep, setRegistrationStep }}>
      {children}
    </RegistrationContext.Provider>
  );
};
